"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingSheet = void 0;
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const claim_1 = require("shared/claim");
const print_util_1 = require("../../print-util");
/**
 * page 1
 * - Billing sheet
 */
class BillingSheet extends print_util_1.PrintUtil {
    constructor(printMeta, lastPage) {
        super();
        this.printMeta = printMeta;
        this.lastPage = lastPage;
        this.make = () => {
            var _a, _b, _c, _d;
            const { claim, barcode, historic } = this.printMeta;
            const currentClaim = mobx_1.toJS(claim);
            const { order } = currentClaim;
            const patient = (_a = historic === null || historic === void 0 ? void 0 : historic.patientData) !== null && _a !== void 0 ? _a : order.patient;
            const provider = (_b = historic === null || historic === void 0 ? void 0 : historic.providerData) !== null && _b !== void 0 ? _b : order.provider;
            const site = (_c = historic === null || historic === void 0 ? void 0 : historic.siteData) !== null && _c !== void 0 ? _c : order.site;
            const patientGender = patient.gender === "1" ? "Male" : "Female";
            const user = (_d = historic === null || historic === void 0 ? void 0 : historic.userData) !== null && _d !== void 0 ? _d : store_1.usersStore.user.value;
            const pageBreak = this.lastPage ? "" : "after";
            return [
                {
                    columnGap: 50,
                    columns: [
                        {
                            // auto-sized columns have their widths based on their content
                            stack: [
                                `Address: ${patient.address || ""}`,
                                `City/State/Zip:${patient.city || ""} ${patient.state ||
                                    ""} ${patient.zip || ""}`,
                                `Home Phone: ${patient.phone || ""}`,
                                `Cell Phone:        `,
                                `Work Phone:        `,
                                `Dispense Time: ${this.orderCreateDate(order.createDate) || ""}`,
                                `Reimbursement:  `,
                                `Site Number#: ${site.ncpdpId || ""}`,
                                `Name: ${site.name || ""}`,
                                `Address: ${site.address || ""} ${site.state || ""} ${site.zip ||
                                    ""}`,
                                `Phone: ${site.phone || ""}`,
                                `Fax: ${site.fax || ""}`,
                                `User: `,
                                `Payer: `,
                                `Address: `,
                                `Phone: `,
                                `Is Dept of Labor: `,
                                `Adjuster: `,
                                `Verfied: `
                            ],
                            // A stack treats each index as its own line.
                            width: "*"
                        },
                        {
                            // star-sized columns fill the remaining space
                            // if there's more than one star-column, available width is divided equally
                            stack: [
                                `Gender: ${patientGender || ""}`,
                                `SSN:`,
                                `DOB: ${patient.birthDate || ""}`,
                                `Claim #: ${claim.rxId.rxId || ""}`,
                                `Injury:`,
                                `Approved:`,
                                `Group:`,
                                `Doc: ${provider.lastName || ""}, ${provider.firstName ||
                                    ""} ${provider.title || ""} (${site.city || ""} ${site.state ||
                                    ""}) ${provider.npiNumber || ""}`,
                                `DEA #: ${provider.dea || ""}`,
                                `State License #: ${provider.stateLicense || ""}`,
                                `Tax ID: `,
                                `NPI: ${provider.npiNumber || ""}`,
                                `Active Prov#: `,
                                `\n\n\n Employer: `,
                                `Address: `,
                                `Phone: `
                            ],
                            width: "*"
                        },
                        // To place an image within a column you must place it within a stack or else it will
                        // not render.
                        {
                            stack: [
                                { image: barcode, width: 100 },
                                `${this.currentDay()} ${this.currentDate()}`,
                                `${user.firstName} ${user.lastName}`,
                                `\n\n\n\n\n\n\n\n\nAttorney: `,
                                `Practice: `,
                                `Address: `,
                                `Phone: `,
                                `Fax: `
                            ],
                            width: 100
                        }
                    ],
                    // optional space between columns
                    style: "tableText"
                },
                {
                    layout: {
                        hLineWidth(i, node) {
                            return i === 0 || i === node.table.body.length ? 1 : 0.5;
                        },
                        vLineWidth(i, node) {
                            return i === 0 || i === node.table.widths.length ? 0.5 : 0.5;
                        }
                    },
                    style: "tableText",
                    table: {
                        // headers are automatically repeated if the table spans over multiple pages
                        // you can declare how many rows should be treated as headers
                        body: this.renderTable(),
                        headerRows: 1,
                        widths: [25, 25, 70, 50, 10, 60, 30, 15, 30, 30, 30, 70]
                    }
                },
                {
                    pageBreak,
                    style: "notice",
                    text: "NOTICE: Page contains private patient information and should be handled in accordance with \n HIPAA guidelines to protect the privacy of the patient"
                }
            ];
        };
        this.normalizeStatus = (status) => {
            let normalizedStatus = "";
            switch (status) {
                case claim_1.ClaimStatus.Dispensed:
                    normalizedStatus = "Dispensed";
                    break;
                case claim_1.ClaimStatus.Error:
                    normalizedStatus = "Error";
                    break;
                case claim_1.ClaimStatus.Paid:
                    normalizedStatus = "Approved";
                    break;
                case claim_1.ClaimStatus.Refill:
                    normalizedStatus = "Refill";
                    break;
                case claim_1.ClaimStatus.Refilled:
                    normalizedStatus = "Refilled";
                    break;
                case claim_1.ClaimStatus.RefillDone:
                    normalizedStatus = "Refill Done";
                    break;
                case claim_1.ClaimStatus.RefillDelayed:
                    normalizedStatus = "Refill Delayed";
                    break;
                case claim_1.ClaimStatus.Reversed:
                    normalizedStatus = "Claim Reversed";
                    break;
                case claim_1.ClaimStatus.ReverseError:
                    normalizedStatus = "Claim Reverse Error";
                    break;
                default:
                    normalizedStatus = "";
                    break;
            }
            return normalizedStatus;
        };
        this.renderTable = () => {
            var _a;
            const { claim, historic } = this.printMeta;
            const currentClaim = mobx_1.toJS(claim);
            const inventoryItem = (_a = historic === null || historic === void 0 ? void 0 : historic.inventoryData) !== null && _a !== void 0 ? _a : currentClaim.inventory;
            const { claimLots } = currentClaim;
            const { quantity } = currentClaim;
            const arr = [
                [
                    "Rx #",
                    "ICD10",
                    "NDC",
                    "RefNDC",
                    "B",
                    "Name",
                    "Form",
                    "Lot",
                    "AWP",
                    "MAC",
                    "Reim",
                    "Status"
                ]
            ];
            for (let i = 0; i < quantity; i++) {
                const newRow = [
                    currentClaim.rxId.rxId || "",
                    "",
                    inventoryItem.package,
                    inventoryItem.package,
                    "",
                    inventoryItem.name,
                    `${inventoryItem.disQty} ${inventoryItem.unit}`,
                    `${claimLots
                        .map((cLot) => cLot.siteLot.lotNumber)
                        .join(", ")}`,
                    inventoryItem.priceAWP,
                    "",
                    currentClaim.totalAmount,
                    this.normalizeStatus(currentClaim.status)
                ];
                arr.push(newRow);
            }
            return arr;
        };
    }
}
exports.BillingSheet = BillingSheet;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/print-manager/sheets/billing-sheet/billing-sheet.ts
// module id = 2723
// module chunks = 0 1